import React from 'react';
import { IconProps } from './types';

const Clock3: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6C0 2.7 2.7 0 6 0C9.3 0 12 2.7 12 6C12 9.3 9.3 12 6 12C2.7 12 0 9.3 0 6ZM1.2 6C1.2 8.625 3.375 10.8 6 10.8C8.625 10.8 10.8 8.625 10.8 6C10.8 3.375 8.625 1.2 6 1.2C3.375 1.2 1.2 3.375 1.2 6Z"
      fill={!ignoreColor ? color : undefined}
    />
    <path
      d="M7.19586 6.38462V6.30769V3.61538C7.19586 3.30769 6.8969 3 6.59793 3C6.29897 3 6 3.23077 6 3.61538V6.30769C6 6.38462 6 6.92308 6.14948 7.15385L8.01802 8.84615C8.1675 8.92308 8.24224 9 8.39172 9C8.54121 9 8.69069 8.92308 8.84017 8.76923C9.06439 8.53846 9.06439 8.15385 8.76543 7.92308L7.19586 6.38462Z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default Clock3;
